define('lib/Podio.Time',['require','jquery','lib/Podio.Config','lib/Podio.Utils','lib/jquery/jquery.timeentry','moment','moment-timezone'],function(require) {

  var $ = require('jquery');
  var podioConfig = require('lib/Podio.Config');
  var utils = require('lib/Podio.Utils');
  require('lib/jquery/jquery.timeentry');
  var moment = require('moment');
  require('moment-timezone');

  var Time = {

    // Return the current datetime in the user's timezone
    current: function() {
      return moment.utc().add(this.getServerTimeOffset(), 'seconds').tz(this.getUserTimeZone());
    },

    // Current UTC time, with adjustment for the server's UTC time
    currentUTC: function() {
      return moment.utc().add(this.getServerTimeOffset(), 'seconds');
    },

    getUserTimeZone: function() {
      return podioConfig.user.timezone;
    },

    getServerTimeOffset: function() {
      return podioConfig.serverTimeOffset;
    },

    // Only updates timezone for the current page request.
    // Does not persist to the server.
    setUserTimeZone: function(timezone) {
      podioConfig.user.timezone = timezone;
    },

    // Convert moment to an API friendly string
    apiFriendlyDateTimeString: function(moment) {
      return moment.format('YYYY-MM-DD HH:mm');
    },

    // Convert moment to an API friendly string
    apiFriendlyDateString: function(moment) {
      return moment.format('YYYY-MM-DD');
    },

    // Convert moment to an API friendly string
    apiFriendlyTimeString: function(moment) {
      return moment.format('HH:mm');
    },

    apiFriendlyTimeStringWithSeconds: function(moment) {
      return moment.format('HH:mm:ss');
    },

    formatTime: function(moment) {
      if($.timeEntry._defaults.show24Hours) {
        return moment.format('HH:mm');
      } else {
        return moment.format('hh:mm A');
      }
    },

    // Pass in UTC dateString in API format, get back moment in user's timezone
    localMomentFromAPIString: function(dateString) {
      return moment.utc(dateString, 'YYYY-MM-DD HH:mm:ss').tz(this.getUserTimeZone());
    },

    // Pass in timezone-less dateString in API format, get back moment
    // Only relevant for date field values
    localMomentFromDateFieldString: function(dateString) {
      return moment(dateString, 'YYYY-MM-DD HH:mm:ss');
    },

    // Pass in dateString, get back moment in user's timezone
    localMomentFromString: function(dateString) {

      // Handle API UTC timestamps
      if (dateString[dateString.length-1] === 'Z') {
        dateString.replace('Z', '+00:00');
      }

      return moment(dateString, 'YYYY-MM-DDTHH:mm:ssZZ').tz(this.getUserTimeZone());

    },

    // Pass in JS date object, get back moment in user's timezone
    localMomentFromDate: function(date) {
      return moment(date).tz(this.getUserTimeZone());
    },

    // Pass in any moment, get it back in the user's timezone
    localMoment: function(moment) {
      return moment.tz(this.getUserTimeZone());
    }

  };

  return Time;

});

